import React from 'react'
import BackgroundImage from '../../assets/bg_section_6.webp'
import MemojiNative from '../../assets/notification/mamoji_native.webp'
import MemojiOptimize from '../../assets/notification/memoji_optimize.webp'
import MemojiCreate from '../../assets/notification/memoji_create.webp'
import { useState, useEffect } from 'react'

const ITEMS = [
    { memoji: MemojiNative, title: 'Navigate', description: 'We guide you through the complexities of digital technology for informed decision-making.' },
    { memoji: MemojiOptimize, title: 'Optimize', description: 'We streamline operations and utilize resources efficiently for optimal business performance.' },
    { memoji: MemojiCreate, title: 'Transform', description: 'Leveraging cutting-edge technology, we revamp your mobile platforms for enhanced visibility and reach.' },
    { memoji: MemojiOptimize, title: 'Create', description: 'Our team designs intuitive interfaces that drive user engagement and foster loyalty.' },
    { memoji: MemojiNative, title: 'Harness', description: 'Embrace the latest tech advancements with us to stay ahead and drive growth in your industry.' },
]

const STAGGER_MS = 110

export default function AppsCompreomisses(props) {
    /* How many cards have arrived. The list used to be five independent
     * booleans fed by four uncleaned setTimeouts. */
    const [revealed, setRevealed] = useState(0)

    useEffect(() => {
        if (!props.inView) return undefined
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            setRevealed(ITEMS.length)
            return undefined
        }
        const timers = ITEMS.map((_, i) =>
            setTimeout(() => setRevealed((n) => Math.max(n, i + 1)), 200 + i * STAGGER_MS)
        )
        return () => timers.forEach(clearTimeout)
    }, [props.inView])

    return (
        <section
            id="notifications"
            ref={props.sectionRef}
            className="AppsCompreomisses relative w-full min-h-[100svh] bg-no-repeat bg-cover flex flex-col">

            <img src={BackgroundImage} alt="" width={960} height={640} className="absolute inset-0 w-full h-full object-cover z-0" loading="lazy" />
            <div className="h-full w-full flex flex-1 flex-col items-center justify-start z-20">

                {/* Spacing is CSS. It used to be an offsetHeight measurement
                    compared against a JS-measured viewport height, which the
                    prerender pass then baked in as an inline pixel margin. */}
                <div data-reveal className="w-full flex flex-col items-center justify-center mt-[80px] c-lg:mt-[90px] c-xl:mt-[125px]">
                    <h2 className="w-full text-center notifs-title-size font-bold text-white px-[36px] [text-shadow:_0_2px_14px_rgba(0,0,0,0.45)]">
                        APPS WITHOUT COMPROMISES
                    </h2>
                    <p className="w-full text-center notifs-subtitle-size text-white mt-[16px] c-md:mt-[26px] c-lg:mt-[34px] [text-shadow:_0_2px_12px_rgba(0,0,0,0.4)]">
                        <b>NOTCH</b> up your mobile experience!
                    </p>
                </div>

                <div ref={props.revealRef} className="w-full items-center justify-center h-full flex flex-1">
                    {/* Column width follows the viewport's shape in CSS
                        (.notif-column) rather than a JS aspect-ratio branch. */}
                    <div className="notif-column flex flex-col items-center justify-center px-[24px] nav-sm:px-4 z-10 my-[30px]">
                        {/* ONE list. The five cards used to be rendered twice —
                            once absolutely positioned and animated, once again
                            at opacity 0.01 purely as a height spacer. opacity
                            is not aria-hidden, so every screen reader read all
                            five items twice, and the duplicate text shipped in
                            the prerendered HTML. The stack reserves its own
                            height now because the cards never leave the flow. */}
                        <ul className="w-full flex flex-col gap-[4px] nav-sm:gap-[9px] list-none">
                            {ITEMS.map((item, i) => (
                                <NotificationItem key={item.title} {...item} isVisible={i < revealed} />
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

function NotificationItem({ memoji, title, description, isVisible }) {
    return (
        // Dark glass (was white-glass bg-[#ffffff29]): the wallpaper behind is
        // bright, so white titles + the orange N-O-T-C-H letters were washing
        // out. A dark tint keeps them readable over any wallpaper region.
        <li
            className={`notif-item ${isVisible ? 'visible' : ''} w-full flex bg-[#1C1B20]/55 notif-item-vetical-padding rounded-[34px] notif-background`}>
            <span className="notif-item-image-size flex-shrink-0 block">
                <img src={memoji} alt="" width={128} height={118} className="h-full w-full object-contain" loading="lazy" />
            </span>
            <span className="flex flex-col w-full">
                {/* First letter in Gravisun orange so the five titles spell out N-O-T-C-H. */}
                <span className="notif-title-font-size text-white font-medium">
                    <span className="text-[#EA7E4C]">{title.charAt(0)}</span>
                    {title.slice(1)}
                </span>
                <span className="notif-title-description-size text-white mt-1">{description}</span>
            </span>
        </li>
    )
}
